<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: { type: String, default: '' },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  actionLabel: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  error: { type: String, default: '' },
  empty: { type: Boolean, default: false },
  emptyTitle: { type: String, default: '' },
  emptyDescription: { type: String, default: '' },
});

defineEmits(['action', 'retry']);

const stateType = computed(() => {
  if (props.loading) return 'loading';
  if (props.error) return 'error';
  if (props.empty) return 'empty';
  return props.type || 'empty';
});

const stateTitle = computed(() => {
  if (props.loading) return props.title || 'Carregando…';
  if (props.error) return props.title || 'Não foi possível carregar agora';
  if (props.empty) return props.emptyTitle || props.title || 'Nada por aqui ainda';
  return props.title;
});

const stateMessage = computed(() => {
  if (props.error) return props.error;
  if (props.empty) return props.emptyDescription || props.message;
  return props.message;
});

const iconForType = type => {
  if (type === 'loading') return 'i-lucide-loader-circle animate-spin';
  if (type === 'error') return 'i-lucide-cloud-off';
  if (type === 'success') return 'i-lucide-circle-check';
  return 'i-lucide-inbox';
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section
    class="flex min-h-52 flex-col items-center justify-center rounded-lais border border-dashed border-lais-border bg-white px-6 py-10 text-center"
    :aria-live="stateType === 'loading' ? 'polite' : 'assertive'"
  >
    <span
      class="mb-3 size-8 text-lais-primary"
      :class="iconForType(stateType)"
      aria-hidden="true"
    />
    <h2 class="font-redHatDisplay text-lg font-semibold text-lais-text">
      {{ stateTitle }}
    </h2>
    <p v-if="stateMessage" class="mt-2 max-w-md text-sm text-lais-text-body">
      {{ stateMessage }}
    </p>
    <button
      v-if="actionLabel"
      type="button"
      class="mt-5 rounded-lais border border-lais-border px-4 py-2 text-sm font-semibold text-lais-primary transition hover:bg-lais-primary-50 focus-visible:outline-none focus-visible:shadow-lais-focus"
      @click="$emit('action')"
    >
      {{ actionLabel }}
    </button>
    <button
      v-if="error && !actionLabel"
      type="button"
      class="mt-5 rounded-lais border border-lais-border px-4 py-2 text-sm font-semibold text-lais-primary transition hover:bg-lais-primary-50 focus-visible:outline-none focus-visible:shadow-lais-focus"
      @click="$emit('retry')"
    >
      Tentar novamente
    </button>
    <slot name="action" />
  </section>
</template>
